export default __webpack_public_path__ + "static/media/Facebook.5b4225fa.png";